module.exports = __webpack_public_path__ + "img/call-voice.7ec62eb4.svg";